import {useIntl} from 'react-intl';

const PAGE_SIZE_LIST = [5, 10, 20, 50];
export const DEFAULT_PAGE_SIZE = 5;

interface TablePageSizeSelectorProps {
    pageSizeState: number;
    setPageSize: (selectedValue: number) => void;
}

const TablePageSizeSelector = ({
    pageSizeState,
    setPageSize,
}: TablePageSizeSelectorProps): JSX.Element => {
    const intl = useIntl();
    const pageName = intl.formatMessage({id: 'TABLE.PAGESIZE.DISPLAY'});

    return (
        <div className="d-flex fs-5 fw-semibold">
            <select
                className="form-select form-select-sm pe-12 mx-2"
                value={pageSizeState}
                onChange={(e) => {
                    const selectedValue = Number(e.target.value);
                    setPageSize(selectedValue);
                }}
            >
                {PAGE_SIZE_LIST.map((pageSize) => (
                    <option key={pageSize} value={pageSize} defaultValue={pageSizeState}>
                        {pageSize} / {pageName}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default TablePageSizeSelector;
